import {useRef, useState} from "react";
import {isFunction} from 'lodash'
import {ButtonGroup, IconButton, Stack, } from "@mui/material";
import {Add, MoreVert} from "@mui/icons-material";
import useToggle from "../../../shared/functions/useToggle";
import ItemsAutoComplete from "../../_customs/ItemsAutoComplete";

export default function OrderCartOptions({onAddItems,}) {
    const anchor = useRef();
    const [values, setValues] = useState([]);
    const { handleClose, } = useToggle()

    const handleClosing = () => {
        handleClose()
        setValues([])
    }
 
    const handleSelection = () => {
        isFunction(onAddItems) && onAddItems(values);
        handleClosing()
    }


    return (
        <ButtonGroup component={Stack} direction={'row'}>

            <ItemsAutoComplete
                multiple
                value={values}
                onChange={setValues}
            />

            <IconButton color={'primary'} onClick={handleSelection}>
                <Add/>
            </IconButton>

            <IconButton ref={anchor}>
                <MoreVert/>
            </IconButton>

        </ButtonGroup>
    )
}